import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useAnalytics } from '../../analytics/hooks';

const ListContainer = styled.div`
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
`;

const Filters = styled.div`
  display: flex;
  gap: 20px;
  margin-bottom: 30px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
`;

const AstrologerCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
`;

const AstrologerImage = styled.img`
  width: 90px;
  height: 110px;
  border-radius: 8px;
  object-fit: cover;
  margin-bottom: 15px;
  border: 2px solid rgba(218, 165, 32, 0.15);
`;

const AstrologerInfo = styled.div`
  text-align: center;
`;

const Name = styled.h3`
  margin: 0 0 10px 0;
  color: #333;
`;

const Rate = styled.p`
  color: #666;
  margin: 5px 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 15px;
`;

const Button = styled.button`
  flex: 1;
  padding: 8px;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  
  &.profile {
    background: #f0f0f0;
  }
  
  &.chat {
    background: var(--primary-color);
  }
`;

const AstrologerList = () => {
  const [astrologers, setAstrologers] = useState([]);
  const [filters, setFilters] = useState({
    specialization: '',
    onlineOnly: false,
    sortBy: 'rating_high'
  });
  const navigate = useNavigate();
  const { track } = useAnalytics();

  useEffect(() => {
    fetchAstrologers();
  }, [filters]);

  const fetchAstrologers = async () => {
    try {
      const queryParams = new URLSearchParams({
        specialization: filters.specialization,
        online_only: filters.onlineOnly,
        sort_by: filters.sortBy
      });
      
      const response = await fetch(`/api/astrologers?${queryParams}`);
      const data = await response.json();
      setAstrologers(data.astrologers);
    } catch (error) {
      console.error('Error fetching astrologers:', error);
    }
  };

  return (
    <ListContainer>
      <Filters>
        <select 
          value={filters.specialization}
          onChange={(e) => setFilters({...filters, specialization: e.target.value})}
        >
          <option value="">All Specializations</option>
          <option value="vedic">Vedic</option>
          <option value="tarot">Tarot</option>
          <option value="numerology">Numerology</option>
        </select>

        <select
          value={filters.sortBy}
          onChange={(e) => setFilters({...filters, sortBy: e.target.value})}
        >
          <option value="rating_high">Highest Rating</option>
          <option value="price_low">Lowest Price</option>
          <option value="experience_high">Most Experienced</option>
        </select>

        <label>
          <input
            type="checkbox"
            checked={filters.onlineOnly}
            onChange={(e) => setFilters({...filters, onlineOnly: e.target.checked})}
          />
          Online Only
        </label>
      </Filters>

      <Grid>
        {astrologers.map(astrologer => (
          <AstrologerCard key={astrologer.id}>
            <AstrologerInfo>
              <AstrologerImage src={astrologer.profile_image || '/default-avatar.png'} alt={astrologer.name} />
              <Name>{astrologer.name}</Name>
              <Rate>₹{astrologer.price_per_minute_chat}/min</Rate>
              <p>{astrologer.specialization}</p>
              <p>⭐ {astrologer.rating.toFixed(1)} ({astrologer.total_consultations} sessions)</p>
              <ButtonGroup>
                <Button
                  className="profile"
                  onClick={() => {
                    track('astrologer_viewed', { astrologer_id: astrologer.id, source: 'list' });
                    navigate(`/astrologer/${astrologer.id}`);
                  }}
                >
                  View Profile
                </Button>
                <Button 
                  className="chat"
                  onClick={() => navigate(`/chat/${astrologer.id}`)}
                  disabled={!astrologer.is_online}
                >
                  {astrologer.is_online ? 'Chat Now' : 'Offline'}
                </Button>
              </ButtonGroup>
            </AstrologerInfo>
          </AstrologerCard>
        ))}
      </Grid>
    </ListContainer>
  );
};

export default AstrologerList;